module.exports = __webpack_public_path__ + "static/media/add-new-app-icon.41012f14.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/add-new-app-icon.svg
// module id = 544
// module chunks = 0